module.exports = __webpack_public_path__ + "images/a81c484d.top_bkgnd.png";


//////////////////
// WEBPACK FOOTER
// ./images/top_bkgnd.png
// module id = 277
// module chunks = 0